import React, { useState } from "react";
import styled from "styled-components";
import Input from "sushiweb/InputTypes/Input";

import styles from "../../../constants/assets/variables";

const TableSearch = (props) => {
  const [inputValue, setInputValue] = useState("");

  const handleChange = (val) => {
    props.onChange(val);
    setInputValue(val);
  };

  return (
    <TableSearchContainer
      className="flex justify-end sushi-searchbox mx-0 my-0"
      id="localTableSearch"
    >
      <Input
        onChange={handleChange}
        borderColor={styles.primaryColor}
        innerWidth="200px"
        label="Search In Table"
        value={inputValue}
      />
    </TableSearchContainer>
  );
};

const TableSearchContainer = styled.div`
  height: 60px !important;
`;

export default TableSearch;
